import { render, staticRenderFns } from "./ASideBox.vue?vue&type=template&id=460fbe13&"
import script from "./ASideBox.vue?vue&type=script&lang=js&"
export * from "./ASideBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports